import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";
import Button, { EButtonstyletype, EButtonVariant } from "@Front/Components/DesignSystem/Button";
import classes from "../classes.module.scss";
import type { StepTotpResendCooldown } from "../hooks/useStepTotpResendCooldown";

type Props = {
	resendQuestion: string;
	resendCta: string;
	resendTimer: string;
	cooldown: StepTotpResendCooldown;
};

export function StepTotpResendBlock(props: Props): React.JSX.Element {
	const { resendQuestion, resendCta, resendTimer, cooldown } = props;
	const { disableNewCodeButton, secondsBeforeNewCode, sendAnotherCode } = cooldown;

	return (
		<div className={classes["ask-another-code"]}>
			<Typography typo={ETypo.TEXT_MD_REGULAR}>{resendQuestion}</Typography>
			<Button
				variant={EButtonVariant.PRIMARY}
				styletype={EButtonstyletype.TEXT}
				disabled={disableNewCodeButton}
				data-disabled={disableNewCodeButton.toString()}
				onClick={sendAnotherCode}
				className={classes["new-code-button"]}>
				{resendCta}
			</Button>
			{secondsBeforeNewCode !== 0 && (
				<Typography typo={ETypo.TEXT_MD_SEMIBOLD} className={classes["new-code-timer"]}>
					{resendTimer}
					<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.COLOR_SECONDARY_500}>
						00:{secondsBeforeNewCode < 10 ? `0${secondsBeforeNewCode}` : secondsBeforeNewCode}
					</Typography>
				</Typography>
			)}
		</div>
	);
}
